import React from 'react';
import { BellOff } from 'lucide-react';
import './EmptyState.css';

export interface EmptyStateProps {
  variant: 'all-empty' | 'no-unread';
}

export const EmptyState: React.FC<EmptyStateProps> = ({ variant }) => {
  if (variant === 'all-empty') {
    return (
      <div className="notif-empty">
        <BellOff size={32} className="notif-empty__icon" />
        <p className="notif-empty__title">Пока нет уведомлений</p>
        <p className="notif-empty__sub">Мы сообщим, когда что-то случится</p>
      </div>
    );
  }

  return (
    <div className="notif-empty">
      <p className="notif-empty__title">Нет непрочитанных</p>
      <p className="notif-empty__sub">Всё под контролем</p>
    </div>
  );
};

export default EmptyState;
